module.exports = __webpack_public_path__ + "img/wizard-loader-3.e0a42f6a.png";